import { Injectable } from '@angular/core';
import { createEffect, ofType, Actions, act } from '@ngrx/effects';
import { Store } from '@ngrx/store';
// import { AppState } from '@capacitor/app';
import { failedTransaction, setLoadingSpinner } from '../actions/shared.action';
import { catchError, exhaustMap, filter, map, mergeMap, of, tap } from 'rxjs';
import { ROUTER_NAVIGATION, RouterNavigatedAction } from '@ngrx/router-store';
import * as fromTournamentActions from '../actions/tournament.action'
import { APIResponse } from 'src/app/models/api-response.model';
import { AccountService } from 'src/app/services/account.service';
import { NavigationExtras, Router } from '@angular/router';
import { TournamentService } from 'src/app/services/tournament.service';
import { AppState } from '../app.state';
import { ModalService } from 'src/app/services/modal.service';

@Injectable()
export class TournamentEffects {

  getSeasons$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ROUTER_NAVIGATION),
      filter((r : RouterNavigatedAction) => {
        return r.payload.routerState.url.startsWith('/home/tournament');
      }),
      exhaustMap((action) =>
        this.tournamentService.getSeasons().pipe(
          map((response) => { 
            console.log('getSeasons$', response);
            return fromTournamentActions.getSeasonsSuccess({ data: response?.details});
          }),
          catchError((response) => {
            return of(failedTransaction({ data: response.error }));
          })
        )
      )
    )
  });

  reloadSeason$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromTournamentActions.getSeasons),
      mergeMap(() => {
        return this.tournamentService.getSeasons().pipe(
          map((response: APIResponse) => {           
            console.log('getSeasons$', response);
            return fromTournamentActions.getSeasonsSuccess({ data: response?.details});
          })
        );
      })
    )
  );

  createSeason$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromTournamentActions.createSeason),
      exhaustMap((action) =>
        this.tournamentService.createSeason(action.data).pipe(
          map((response) => {
            return fromTournamentActions.createSeasonSuccess({ data: response });
          }),
          catchError((response) => {
            console.error('createSeason$', response);
            return of(fromTournamentActions.createSeasonFailed({ data: response }));
          })
        )
      )
    )
  );

  createSeasonSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromTournamentActions.createSeasonSuccess),
        tap(async (action) => {
          this.modalService.hideCreateSeason();
          this.store.dispatch(fromTournamentActions.getSeasons());
          const success = {
            message: 'Create Season Success'
          }
          this.modalService.successModal(success);
          this.modalService.hideLoadingSpinner();
          console.log('createSeasonSuccess$', action.data);
        })
      ),
    { dispatch: false }
  );

  createSeasonFailed$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromTournamentActions.createSeasonFailed),
        tap(async (action) => {
          console.log('createSeasonFailed$', action.data);
          const error = {
            message: action.data?.error?.message
          }
          this.modalService.errorModal(error);
          this.modalService.hideLoadingSpinner();
        })
      ),
    { dispatch: false }
  );

  getLeagues$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromTournamentActions.getLeagues),
      mergeMap((action) => {
        return this.tournamentService.getLeagues(action.data?.seasonId).pipe(
          map((response: APIResponse) => {      
            this.modalService.hideLoadingSpinner();     
            console.log('getLeagues$', response);
            const data = {
              season: action?.data,
              leagues: response.details
            }
            if(action.redirect){
              this.router.navigateByUrl('/home/season/leagues');
            }
            return fromTournamentActions.getLeaguesSuccess({ data });
          })
        );
      })
    )
  );

  createSeasonLeague$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromTournamentActions.createSeasonLeague),
      exhaustMap((action) =>
        this.tournamentService.createSeasonLeague(action.data).pipe(
          map((response) => {
            return fromTournamentActions.createSeasonLeagueSuccess({ data: action.data });
          }),
          catchError((response) => {
            console.error('createSeason$', response);
            return of(fromTournamentActions.createSeasonLeagueFailed({ data: response }));
          })
        )
      )
    )
  );

  createSeasonLeagueSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromTournamentActions.createSeasonLeagueSuccess),
        tap(async (action) => {
          this.modalService.hideCreateSeasonLeague();
          const success = {
            message: 'Create Season League Success'
          }
          this.modalService.successModal(success);
          this.store.dispatch(fromTournamentActions.getLeagues({data: action?.data, redirect: false}));
          console.log('createSeasonLeagueSuccess$', action.data);
        })
      ),
    { dispatch: false }
  );

  createSeasonLeagueFailed$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromTournamentActions.createSeasonLeagueFailed),
        tap(async (action) => {
          console.log('createSeasonLeagueFailed$', action.data);
          this.modalService.hideLoadingSpinner();
          const error = {
            message: action.data?.error?.message
          }
          this.modalService.errorModal(error);
        })
      ),
    { dispatch: false }
  );

  updateSeasonLeague$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromTournamentActions.updateSeasonLeague),
      exhaustMap((action) =>
        this.tournamentService.updateSeasonLeague(action.data).pipe(
          map((response) => {
            return fromTournamentActions.updateSeasonLeagueSuccess({ data: action.data });
          }),
          catchError((response) => {
            console.error('updateSeasonLeague$', response);
            return of(fromTournamentActions.updateSeasonLeagueFailed({ data: response }));
          })
        )
      )
    )
  );

  updateSeasonLeagueSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromTournamentActions.updateSeasonLeagueSuccess),
        tap(async (action) => {
          this.modalService.hideUpdateSeasonLeague();
          const success = {
            message: 'Update Season League Success'
          }
          this.modalService.hideLoadingSpinner();
          this.modalService.successModal(success);
          this.store.dispatch(fromTournamentActions.getLeagues({data: action?.data, redirect: false}));
          console.log('updateSeasonLeagueSuccess$', action.data);
        })
      ),
    { dispatch: false }
  );

  updateSeasonLeagueFailed$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromTournamentActions.updateSeasonLeagueFailed),
        tap(async (action) => {
          console.log('updateSeasonLeagueFailed$', action.data);
          const error = {
            message: action.data?.error?.message
          }
          this.modalService.hideLoadingSpinner();
          this.modalService.errorModal(error);
        })
      ),
    { dispatch: false }
  );

  getLeagueDetails$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromTournamentActions.getLeagueDetails),
      exhaustMap((action) =>
        this.tournamentService.getLeagueDetails(action.data).pipe(
          map((response) => {
            return fromTournamentActions.getLeagueDetailsSuccess({ data: action.data });
          }),
          catchError((response) => {
            console.error('getLeagueDetails$', response);
            return of(fromTournamentActions.getLeagueDetailsFailed({ data: response }));
          })
        )
      )
    )
  );

  getLeagueDetailsSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromTournamentActions.getLeagueDetailsSuccess),
        tap(async (action) => {
          this.modalService.hideLoadingSpinner();
          console.log('getLeagueDetailsSuccess$', action.data);
        })
      ),
    { dispatch: false }
  );

  getLeagueDetailsFailed$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromTournamentActions.getLeagueDetailsFailed),
        tap(async (action) => {
          console.log('getLeagueDetailsFailed$', action.data);
          const error = {
            message: action.data?.error?.message
          }
          this.modalService.hideLoadingSpinner();
          this.modalService.errorModal(error);
        })
      ),
    { dispatch: false }
  );

  getLeagueGames$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromTournamentActions.getLeagueGames),
      exhaustMap((action) =>
        this.tournamentService.getLeagueGames(action.data).pipe(
          map((response) => {
            const data = {
              details: response?.details,
              league: action.league
            }
            return fromTournamentActions.getLeagueGamesSuccess({ data, league: action?.league, redirect: action?.redirect });
          }),
          catchError((response) => {
            console.error('getLeagueGames$', response);
            return of(fromTournamentActions.getLeagueGamesFailed({ data: response }));
          })
        )
      )
    )
  );

  getLeagueGamesSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromTournamentActions.getLeagueGamesSuccess),
        tap(async (action) => {
          this.modalService.hideLoadingSpinner();
          if(action?.redirect){
            this.router.navigateByUrl('/home/season/leagues/league-games')
          } else{
            const success = {
              message: 'The game ended successfully'
            }
            this.modalService.successModal(success);
          }
          console.log('getLeagueGamesSuccess$', action.data);
        })
      ),
    { dispatch: false }
  );

  getLeagueGamesFailed$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromTournamentActions.getLeagueGamesFailed),
        tap(async (action) => {
          this.modalService.hideLoadingSpinner();
          console.log('getLeagueGamesFailed$', action.data);
          const error = {
            message: action.data?.error?.message
          }
          this.modalService.errorModal(error);
        })
      ),
    { dispatch: false }
  );

  getLeaguePlayers$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromTournamentActions.getLeaguePlayers),
      exhaustMap((action) =>
        this.tournamentService.getLeaguePlayers(action.data).pipe(
          map((response) => {
            return fromTournamentActions.getLeaguePlayersSuccess({ data: response.details, league: action?.league, redirect: true });
          }),
          catchError((response) => {
            console.error('getLeaguePlayers$', response);
            return of(fromTournamentActions.getLeaguePlayersFailed({ data: response }));
          })
        )
      )
    )
  );

  getLeaguePlayersSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromTournamentActions.getLeaguePlayersSuccess),
        tap(async (action) => {
          this.modalService.hideLoadingSpinner();
          if(action.redirect){
            this.router.navigateByUrl('/home/season/leagues/league-players')
          }
          console.log('getLeaguePlayersSuccess$', action);
        })
      ),
    { dispatch: false }
  );

  getLeaguePlayersFailed$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromTournamentActions.getLeaguePlayersFailed),
        tap(async (action) => {
          this.modalService.hideLoadingSpinner();
          console.log('getLeaguePlayersFailed$', action.data);
          const error = {
            message: action.data?.error?.message
          }
          this.modalService.errorModal(error);
        })
      ),
    { dispatch: false }
  );
  
  createLeaguePlayers$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromTournamentActions.createLeaguePlayers),
      exhaustMap((action) =>
        this.accountService.createPlayer(action.data).pipe(
          map((response) => {
            return fromTournamentActions.createLeaguePlayersSuccess({ data: response.details, league: action?.league });
          }),
          catchError((response) => {
            console.error('getLeaguePlayers$', response);
            return of(fromTournamentActions.createLeaguePlayersFailed({ data: response }));
          })
        )
      )
    )
  );

  createLeaguePlayersSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromTournamentActions.createLeaguePlayersSuccess),
        tap(async (action) => {
          this.modalService.hideLoadingSpinner();
          this.modalService.hideReviewDetails();
          this.modalService.hideCreateLeaguePlayer();
          const success = {
            message: 'Create League Player Success'
          }
          this.modalService.successModal(success);
          this.store.dispatch(fromTournamentActions.getLeaguePlayers({data: action.league.leagueId, league: action.league, redirect: false}))
          console.log('createLeaguePlayersSuccess$', action);
        })
      ),
    { dispatch: false }
  );

  createLeaguePlayersFailed$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromTournamentActions.createLeaguePlayersFailed),
        tap(async (action) => {
          this.modalService.hideLoadingSpinner();
          console.log('createLeaguePlayersFailed$', action.data);
          const error = {
            message: action.data?.error?.message
          }
          this.modalService.errorModal(error);
        })
      ),
    { dispatch: false }
  );

  getTournamentBracket$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromTournamentActions.getTournamentBracket),
      exhaustMap((action) =>
        this.tournamentService.getTournamentBracket(action.data).pipe(
          map((response) => {
            const data = {
              details: response.details,
              league: action.league
            }
            console.log('getTournamentBracket$', response);
            return fromTournamentActions.getTournamentBracketSuccess({ data, league: action?.league, redirect: action?.redirect });
          }),
          catchError((response) => {
            console.error('getTournamentBracket$', response);
            return of(fromTournamentActions.getTournamentBracketFailed({ data: response }));
          })
        )
      )
    )
  );

  getTournamentBracketSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromTournamentActions.getTournamentBracketSuccess),
        tap(async (action) => {
          this.modalService.hideLoadingSpinner();
          if(action?.redirect){
            this.router.navigateByUrl('/home/season/leagues/tournament-bracket')
          }
          console.log('getTournamentBracketSuccess$', action);
        })
      ),
    { dispatch: false }
  );

  getTournamentBracketFailed$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromTournamentActions.getTournamentBracketFailed),
        tap(async (action) => {
          this.modalService.hideLoadingSpinner();
          console.log('getTournamentBracketFailed$', action.data);
          const error = {
            message: action.data?.error?.message
          }
          this.modalService.errorModal(error);
        })
      ),
    { dispatch: false }
  );

  // tournament effects

  assignSeeds$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromTournamentActions.assignSeeds),
      exhaustMap((action) =>
        this.tournamentService.assignSeeds(action.data).pipe(
          map((response) => {
            console.log('assignSeeds$', response.details);
            return fromTournamentActions.assignSeedsSuccess({ seasonId: action.seasonId });
          }),
          catchError((response) => {
            console.error('assignSeeds$', response);
            return of(fromTournamentActions.assignSeedsFailed({ data: response }));
          })
        )
      )
    )
  );

  assignSeedsSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromTournamentActions.assignSeedsSuccess),
        tap(async (action) => {
          this.modalService.hideLoadingSpinner();
          console.log('assignSeedsSuccess$', action);
          const data = {
            seasonId: action.seasonId
          }
          this.store.dispatch(fromTournamentActions.getLeagues({data, redirect: false}));
          const success = {
            message: 'League has been seeded successfully'
          }
          this.modalService.successModal(success);
        })
      ),
    { dispatch: false }
  );

  assignSeedsFailed$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromTournamentActions.assignSeedsFailed),
        tap(async (action) => {
          this.modalService.hideLoadingSpinner();
          console.log('assignSeedsFailed$', action.data);
          const error = {
            message: action.data?.error?.message
          }
          this.modalService.errorModal(error);
        })
      ),
    { dispatch: false }
  );

  generateMatchups$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromTournamentActions.generateMatchups),
      exhaustMap((action) =>
        this.tournamentService.generateMatchups(action.data).pipe(
          map((response) => {
            console.log('generateMatchups$', response.details);
            return fromTournamentActions.generateMatchupsSuccess({ seasonId: action.seasonId });
          }),
          catchError((response) => {
            console.error('generateMatchups$', response);
            return of(fromTournamentActions.generateMatchupsFailed({ data: response }));
          })
        )
      )
    )
  );

  generateMatchupsSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromTournamentActions.generateMatchupsSuccess),
        tap(async (action) => {
          this.modalService.hideLoadingSpinner();
          const data = {
            seasonId: action.seasonId
          }
          this.store.dispatch(fromTournamentActions.getLeagues({data, redirect: false}));
          const success = {
            message: 'Generate Matchup Success'
          }
          this.modalService.successModal(success);
        })
      ),
    { dispatch: false }
  );

  generateMatchupsFailed$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromTournamentActions.generateMatchupsFailed),
        tap(async (action) => {
          this.modalService.hideLoadingSpinner();
          console.log('generateMatchupsFailed$', action.data);
          const error = {
            message: action.data?.error?.message
          }
          this.modalService.errorModal(error);
        })
      ),
    { dispatch: false }
  );

  startLeagueTournament$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromTournamentActions.startLeagueTournament),
      exhaustMap((action) =>
        this.tournamentService.startLeagueTournament(action.data).pipe(
          map((response) => {
            console.log('startLeagueTournament$', response.details);
            return fromTournamentActions.startLeagueTournamentSuccess({ seasonId: action.seasonId });
          }),
          catchError((response) => {
            console.error('startLeagueTournament$', response);
            return of(fromTournamentActions.startLeagueTournamentFailed({ data: response }));
          })
        )
      )
    )
  );

  startLeagueTournamentSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromTournamentActions.startLeagueTournamentSuccess),
        tap(async (action) => {
          this.modalService.hideLoadingSpinner();
          const data = {
            seasonId: action.seasonId
          }
          this.store.dispatch(fromTournamentActions.getLeagues({data, redirect: false}));
          const success = {
            message: 'The League has been started'
          }
          this.modalService.successModal(success);
        })
      ),
    { dispatch: false }
  );

  startLeagueTournamentFailed$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromTournamentActions.startLeagueTournamentFailed),
        tap(async (action) => {
          this.modalService.hideLoadingSpinner();
          const error = {
            message: action.data?.error?.message
          }
          this.modalService.errorModal(error);
          console.log('startLeagueTournamentFailed$', action.data);
        })
      ),
    { dispatch: false }
  );

  generateNextRound$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromTournamentActions.generateNextRound),
      exhaustMap((action) =>
        this.tournamentService.generateNextRound(action.data).pipe(
          map((response) => {
            console.log('generateNextRound$', response.details);
            return fromTournamentActions.generateNextRoundSuccess({ seasonId: action.seasonId });
          }),
          catchError((response) => {
            console.error('generateNextRound$', response);
            return of(fromTournamentActions.generateNextRoundFailed({ data: response }));
          })
        )
      )
    )
  );

  generateNextRoundSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromTournamentActions.generateNextRoundSuccess),
        tap(async (action) => {
          this.modalService.hideLoadingSpinner();
          const data = {
            seasonId: action.seasonId
          }
          this.store.dispatch(fromTournamentActions.getLeagues({data, redirect: false}));
          const success = {
            message: 'Generate Next Round Success'
          }
          this.modalService.successModal(success);
        })
      ),
    { dispatch: false }
  );

  generateNextRoundFailed$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromTournamentActions.generateNextRoundFailed),
        tap(async (action) => {
          this.modalService.hideLoadingSpinner();
          const error = {
            message: action.data?.error?.message
          }
          this.modalService.errorModal(error);
          console.log('generateNextRoundFailed$', action.data);
        })
      ),
    { dispatch: false }
  );

  completeLeagueTournament$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromTournamentActions.completeLeagueTournament),
      exhaustMap((action) =>
        this.tournamentService.completeLeagueTournament(action.data).pipe(
          map((response) => {
            console.log('completeLeagueTournament$', response.details);
            return fromTournamentActions.completeLeagueTournamentSuccess({ seasonId: action.seasonId });
          }),
          catchError((response) => {
            console.error('completeLeagueTournament$', response);
            return of(fromTournamentActions.completeLeagueTournamentFailed({ data: response }));
          })
        )
      )
    )
  );

  completeLeagueTournamentSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromTournamentActions.completeLeagueTournamentSuccess),
        tap(async (action) => {
          this.modalService.hideLoadingSpinner();
          const data = {
            seasonId: action.seasonId
          }
          this.store.dispatch(fromTournamentActions.getLeagues({data  , redirect: false}));
          const success = {
            message: 'Complete Tournament Success'
          }
          this.modalService.successModal(success);
        })
      ),
    { dispatch: false }
  );

  completeLeagueTournamentFailed$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromTournamentActions.completeLeagueTournamentFailed),
        tap(async (action) => {
          this.modalService.hideLoadingSpinner();
          const error = {
            message: action.data?.error?.message
          }
          this.modalService.errorModal(error);
          console.log('completeLeagueTournamentFailed$', action.data);
        })
      ),
    { dispatch: false }
  );

  getLeagueScorers$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromTournamentActions.getLeagueScorers),
      exhaustMap((action) =>
        this.tournamentService.getLeagueScorers(action.data).pipe(
          map((response) => {
            return fromTournamentActions.getLeagueScorersSuccess({ data: response.details, league: action?.league, redirect: true });
          }),
          catchError((response) => {
            console.error('getLeagueScorers$', response);
            return of(fromTournamentActions.getLeagueScorersFailed({ data: response }));
          })
        )
      )
    )
  );

  getLeagueScorersSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromTournamentActions.getLeagueScorersSuccess),
        tap(async (action) => {
          this.modalService.hideLoadingSpinner();
          if(action.redirect){
            this.router.navigateByUrl('/home/season/leagues/league-scorers')
          }
          console.log('getLeagueScorersSuccess$', action);
        })
      ),
    { dispatch: false }
  );

  getLeagueScorersFailed$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromTournamentActions.getLeagueScorersFailed),
        tap(async (action) => {
          this.modalService.hideLoadingSpinner();
          console.log('getLeagueScorersFailed$', action.data);
          const error = {
            message: action.data?.error?.message
          }
          this.modalService.errorModal(error);
        })
      ),
    { dispatch: false }
  );

  scorerJoinLeague$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromTournamentActions.scorerJoinLeague),
      exhaustMap((action) =>
        this.tournamentService.scorerJoinLeague(action.league?.leagueId, action.scorerId).pipe(
          map((response) => {
            console.log('scorerJoinLeague$', response.details);
            return fromTournamentActions.scorerJoinLeagueSuccess({ seasonId: action.seasonId, league: action?.league });
          }),
          catchError((response) => {
            console.error('scorerJoinLeague$', response);
            return of(fromTournamentActions.scorerJoinLeagueFailed({ data: response }));
          })
        )
      )
    )
  );

  scorerJoinLeagueSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromTournamentActions.scorerJoinLeagueSuccess),
        tap(async (action) => {
          this.modalService.hideLoadingSpinner();
          this.store.dispatch(fromTournamentActions.getLeagueScorers({data: action.league?.leagueId, league: action?.league, redirect: false}))
          this.modalService.hideAssignScorers();
          const data = {
            seasonId: action.seasonId
          }
          this.store.dispatch(fromTournamentActions.getLeagues({data  , redirect: false}));
          const success = {
            message: 'Assign Scorer Success'
          }
          this.modalService.successModal(success);
        })
      ),
    { dispatch: false }
  );

  scorerJoinLeagueFailed$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromTournamentActions.scorerJoinLeagueFailed),
        tap(async (action) => {
          this.modalService.hideLoadingSpinner();
          console.log('scorerJoinLeagueFailed$', action.data);
          const error = {
            message: action.data?.error?.message
          }
          this.modalService.errorModal(error);
        })
      ),
    { dispatch: false }
  );

  playerJoinLeague$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromTournamentActions.playerJoinLeague),
      exhaustMap((action) =>
        this.tournamentService.playerJoinLeague(action.data?.leagueId, action.data?.playerId).pipe(
          map((response) => {
            console.log('playerJoinLeague$', response.details);
            return fromTournamentActions.playerJoinLeagueSuccess({ data: response.details, league: action?.league });
          }),
          catchError((response) => {
            console.error('playerJoinLeague$', response);
            return of(fromTournamentActions.playerJoinLeagueFailed({ data: response }));
          })
        )
      )
    )
  );

  playerJoinLeagueSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromTournamentActions.playerJoinLeagueSuccess),
        tap(async (action) => {
          this.modalService.hideLoadingSpinner();
          this.modalService.hideAssignPlayers();
          this.store.dispatch(fromTournamentActions.getLeaguePlayers({data: action.league.leagueId, league: action.league, redirect: false}));
          const success = {
            message: 'Assign Player Success'
          }
          this.modalService.successModal(success);
        })
      ),
    { dispatch: false }
  );

  playerJoinLeagueFailed$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromTournamentActions.playerJoinLeagueFailed),
        tap(async (action) => {
          this.modalService.hideLoadingSpinner();
          console.log('playerJoinLeagueFailed$', action.data);
          const error = {
            message: action.data?.error?.message
          }
          this.modalService.errorModal(error);
        })
      ),
    { dispatch: false }
  );

  constructor(
    private actions$: Actions,
    private tournamentService: TournamentService,
    private router: Router,
    private store: Store<AppState>,
    private modalService: ModalService,
    private accountService: AccountService
    // private store: Store<AppState>,
  ) {}

}
